import AxiosInstance from "./AxiosInstance.js";
import {useCallback, useEffect, useState} from "react";

import AxiosFileSender from "../lib/AxiosFileSender.js";

function useAPIListAllReturn(baseURL, itemURL = baseURL) {
    const [items, setItems] = useState([]);

    const addItem = useCallback((body) => {
        return AxiosFileSender.post(baseURL, body).then(res => {
            setItems(res.data)
            return res.data;
        })
    }, [baseURL]);

    const editItem = useCallback((id, body) => {
        return AxiosFileSender.put(`${itemURL}/${id}`, body).then(res => {
            setItems(res.data);
            return res.data;
        })
    }, [itemURL]);

    const deleteItem = useCallback((id) => {
        return AxiosInstance.delete(`${itemURL}/${id}`).then(res => {
            setItems(res.data)
            return res.data;
        })
    }, [itemURL]);



    useEffect(() => {
        AxiosInstance.get(baseURL).then(res => setItems(res.data)).catch(console.error)
    }, [baseURL]);

    return [items, addItem, editItem, deleteItem, setItems];
}

export default useAPIListAllReturn;
